/**
 * Central inventory category mapping (v6.3).
 *
 * SINGLE SOURCE OF TRUTH for navigation, homepage chips, mobile menu, and
 * search-result chip suggestions. The backend `/api/vehicles?body_style=X`
 * implements the SAME mapping (see /app/backend/routes/vehicles.py).
 *
 * Trax intentionally appears in BOTH "Cars" and "SUVs" — Trax is a small
 * crossover that customers shop both ways. Per the user's spec: never
 * leave a nav item returning zero results when matching inventory exists.
 */

export const CATEGORIES = {
  cars: {
    label: "Cars",
    slug: "cars",
    models: ["Trax", "Malibu", "Camaro", "Corvette"],
    body_style: "car",
    href_new: "/new-vehicles/cars",
    href_used: "/used-vehicles/cars",
  },
  suvs: {
    label: "SUVs",
    slug: "suvs",
    models: [
      "Trax",
      "Trailblazer",
      "Equinox",
      "Blazer",
      "Traverse",
      "Tahoe",
      "Suburban",
      "Equinox EV",
      "Blazer EV",
    ],
    body_style: "suv",
    href_new: "/new-vehicles/suvs",
    href_used: "/used-vehicles/suvs",
  },
  trucks: {
    label: "Trucks",
    slug: "trucks",
    models: [
      "Colorado",
      "Silverado 1500",
      "Silverado 2500",
      "Silverado 3500",
      "Silverado HD",
      "Silverado EV",
    ],
    body_style: "truck",
    href_new: "/new-vehicles/trucks",
    href_used: "/used-vehicles/trucks",
  },
  evs: {
    label: "EVs",
    slug: "evs",
    models: ["Equinox EV", "Blazer EV", "Silverado EV", "Bolt EV", "Bolt EUV"],
    body_style: "ev",
    href_new: "/new-vehicles/evs",
    href_used: "/used-vehicles/evs",
  },
};

// Convenience: nav-ready entries.
export const NEW_CATEGORY_LINKS = [
  ["New Chevrolet Cars", CATEGORIES.cars.href_new, "category-new-cars"],
  ["New Chevrolet SUVs", CATEGORIES.suvs.href_new, "category-new-suvs"],
  ["New Chevrolet Trucks", CATEGORIES.trucks.href_new, "category-new-trucks"],
  ["New Chevrolet EVs", CATEGORIES.evs.href_new, "category-new-evs"],
];

export const USED_CATEGORY_LINKS = [
  ["Used Cars", CATEGORIES.cars.href_used, "category-used-cars"],
  ["Used SUVs", CATEGORIES.suvs.href_used, "category-used-suvs"],
  ["Used Trucks", CATEGORIES.trucks.href_used, "category-used-trucks"],
  ["Used EVs", CATEGORIES.evs.href_used, "category-used-evs"],
];
